<div class="page-container dashboard-page dashboard-page--map-only"
     [attr.data-polygon-loading]="isLoading ? 'true' : 'false'"
     [attr.data-polygon-loaded]="hasData && !isLoading ? 'true' : 'false'">
  <div class="dashboard-map-background" *ngIf="hasData">
    <mgl-map
      class="background-map"
      [style]="'mapbox://styles/mapbox/light-v10'"
      [zoom]="[15.5]"
      [center]="mapCenter"
      [interactive]="false"
      [dragPan]="false"
      [scrollZoom]="false"
      [doubleClickZoom]="false"
      [boxZoom]="false"
      [touchZoomRotate]="false"
      [touchPitch]="false"
      [pitchWithRotate]="false"
      [attributionControl]="false"
      [preserveDrawingBuffer]="true"
      [fadeDuration]="0"
      [accessToken]="mapboxToken">
      <mgl-geojson-source
        id="subject-polygon"
        [data]="polygonGeoJson">
      </mgl-geojson-source>

      <mgl-layer
        id="subject-polygon-fill"
        type="fill"
        source="subject-polygon"
        [paint]="{
          'fill-color': 'rgba(255, 255, 255, 0.01)',
          'fill-opacity': 1
        }">
      </mgl-layer>

      <mgl-layer
        id="subject-polygon-outline"
        type="line"
        source="subject-polygon"
        [paint]="{
          'line-color': '#4A5568',
          'line-width': 2,
          'line-opacity': 1
        }">
      </mgl-layer>

      <mgl-geojson-source
        *ngIf="isochroneData"
        id="isochrone-source"
        [data]="isochroneData">
      </mgl-geojson-source>

      <mgl-layer
        *ngIf="isochroneData"
        id="isochrone-fill"
        type="fill"
        source="isochrone-source"
        [paint]="{
          'fill-color': [
            'interpolate',
            ['linear'],
            ['get', 'contour'],
            5, '#2ecc71',
            10, '#f1c40f',
            15, '#e67e22'
          ],
          'fill-opacity': 0.3
        }">
      </mgl-layer>
    </mgl-map>
  </div>

  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <div *ngIf="qrCodeDataUrl" class="qr-code-container">
    <img [src]="qrCodeDataUrl" alt="QR Code" class="qr-code-image">
  </div>
</div>
